module.exports = __webpack_public_path__ + "static/media/instagram.689bf1b3.svg";